import { Button, FormInput, FormInputMoney, PLACEHOLDERS } from "@farzoom/common-ui-components";
import { AddressSearch, CompanySuggestion } from "@app/common-ui-components";
import { useBgFormContext } from "@app/guranteeFormWrapper";
import { useStyles } from "@app/guranteeFormWrapper/styles";
import { VerticalSpace } from "@app/UI/VerticalSpace";
import { BgFormType } from "@services/guarantees/types";
import { Col, Row, Space, Typography } from "antd";
import { memo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { EmailInput } from "@app/UI/emailInput";
import { BeneficiaryContract } from "./beneficiaryContract";

const { Text } = Typography;

type BeneficiaryItemProps = {
  lotIndex: number;
  bIdx: number;
  onRemove: (idx: number) => void;
  removable: boolean;
};

export const BeneficiaryItem = memo(
  ({ lotIndex, bIdx, onRemove, removable }: BeneficiaryItemProps) => {
    const classes = useStyles();
    const { control, setValue } = useFormContext<BgFormType>();
    const { formDisabled, prefix } = useBgFormContext();

    const currentPrefix = (prefix ? `${prefix}.purchase.lots` : "purchase.lots") as "purchase.lots";

    const beneficiary = useWatch({
      control,
      name: `${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}`,
    });

    return (
      <VerticalSpace className={classes.beneficiaryWrapper}>
        <Row gutter={16}>
          <Col span={18}>
            <CompanySuggestion
              prefix={`${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}`}
              control={control}
              setValue={setValue}
              label="Бенефициар"
              placeholder="Введите название или ИНН"
              getVisibleFieldName={(prfx) => `${prfx}.displayName`}
              hiddenFieldNames={["inn", "kpp", "ogrn"]}
              controlled
              required={!formDisabled}
            />
            <Space>
              {beneficiary?.inn && (
                <Text type="secondary">ИНН: {beneficiary.inn}</Text>
              )}
              {beneficiary?.ogrn && (
                <Text type="secondary">ОГРН: {beneficiary.ogrn}</Text>
              )}
            </Space>
          </Col>
          <Col span={6}>
            <FormInput
              name={`${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.customerRegNum`}
              className={classes.input}
              control={control}
              setValue={setValue}
              label="Регномер"
              required={!formDisabled}
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <FormInput
              name={`${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.deliveryPlace`}
              className={classes.input}
              control={control}
              setValue={setValue}
              label="Место доставки"
              required={!formDisabled}
            />
          </Col>
          <Col span={6}>
            <FormInputMoney
              name={`${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.purchaseAmount`}
              control={control}
              setValue={setValue}
              label="НМЦК"
              controls={false}
              disabled={formDisabled}
              maxLength={25}
              required={!formDisabled}
            />
          </Col>
          <Col span={6}>
            <FormInputMoney
              name={`${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.bgAmount`}
              control={control}
              setValue={setValue}
              label="Сумма гарантии"
              controls={false}
              disabled={formDisabled}
              required={!formDisabled}
              maxLength={25}
            />
          </Col>
        </Row>

        <AddressSearch
          prefix={`${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.actualAddress`}
          control={control}
          setValue={setValue}
          label="Место нахождения бенефициара"
          controlled
          required={!formDisabled}
        />

        <Row gutter={16}>
          <Col span={12}>
            <FormInput
              name={`${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.phone`}
              className={classes.input}
              control={control}
              setValue={setValue}
              label="Телефон"
              placeholder="Введите телефон"
              required={!formDisabled}
            />
          </Col>
          <Col span={12}>
            <EmailInput
              name={`${currentPrefix}.${lotIndex}.beneficiaries.${bIdx}.email`}
              control={control}
              setValue={setValue}
              required={!formDisabled}
            />
          </Col>
        </Row>

        <BeneficiaryContract lotIndex={lotIndex} bIdx={bIdx} />

        {removable && (
          <Button
            className={classes.beneficiaryRemove}
            type="outlined"
            iconName="remove"
            title="Удалить бенефициара"
            onClick={() => onRemove(bIdx)}
          />
        )}
      </VerticalSpace>
    );
  }
);
